<template>
    <div>
        <nav class="navBar" :class="{show: navbarShow}">
            <ul>
                <li :class="{active : (activeNumber == 0)}">
                    <a href="index.html" title="投組建議">
                        投組建議
                    </a>
                </li>
                <li :class="{active : (activeNumber == 1)}">
                    <a href="member-modify.html" title="會員編修">
                        會員編修
                    </a>
                </li>
                <li :class="{active : (activeNumber == 2)}">
                    <a href="subscriptionEDM.html" title="電子報訂閱">
                        電子報訂閱
                    </a>
                </li>
                <li :class="{active : (activeNumber == 3)}">
                    <a href="seminar.html" title="預約說明會">
                        預約說明會
                    </a>
                </li>
                <li>
                    <a href="https://www.franklin.com.tw/ContactUs/Index/DivLeaveMessage" target="_blank" title="聯絡我們">
                        聯絡我們
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: ["activeNumber", "navbarShow"]
}
</script>